import {kButtonStyles} from "../../../constants/styles";
import {SystemSecondaryCustomButton} from "../../buttons/SystemCustomButton";
import {kRefreshTokenKey, kTokenKey, removeLocalItemFromKey} from "../../../services/LocalStorage";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {kInternalRoutes} from "../../../constants/internalRoutes";
import {cleanUserEmail} from "../../../actions/user";

export default function PreviewExerciserUserCard() {
    // Used in PreviewExerciserScreen to display bottom
    // bar with both logout and refresh problem actions

    // PROPERTIES
    // ---- Store
    const dispatch = useDispatch();
    // ---- Navigation
    const navigate = useNavigate();
    const userEmail = useSelector((state) => state.userEmail);

    // BUILD
    return (
        <div className={"w-full flex flex-col space-y-[12px] justify-center items-center"}>
            <div className={"bg-greyLight1 w-full rounded-[12px] px-[16px] py-[12px] flex flex-col space-y-[12px]"}>
                <div className={"w-full flex flex-col space-y-[4px] justify-start items-start text-[14px]"}>
                    <p className={"text-greyLight7"}>
                        {"Bienvenue,"}
                    </p>
                    <p className={"text-greyLight9 font-medium"}>
                        {userEmail}
                    </p>
                </div>
                <SystemSecondaryCustomButton
                    label={"Se déconnecter"}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={true}
                    sizeStyle={kButtonStyles.smallButtonStyle}
                    onButtonClick={logout}
                    extraClass={'animate-appear'}
                />
            </div>

        </div>
    );

    // METHODS
    // ---- Logout current user
    function logout() {
        // Clean local storage
        removeLocalItemFromKey(kTokenKey)
        removeLocalItemFromKey(kRefreshTokenKey)
        // Clean current user
        dispatch(cleanUserEmail())
        // Navigate to home
        navigate(kInternalRoutes.home)
    }
}